import { FC, useState } from "react"
import { ConnectorFormValues } from "../../../../../../../types"
import ConnectorFormInput from "../../components/ConnectorFormInput"

interface AdvancedSettingsSectionProps {
  values: ConnectorFormValues
  onHeadersChange: (headersJson: string) => {
    success: boolean
    error: string | null
  }
  onTimeoutChange: (timeout: number) => void
  onBasicAuthChange: (field: "username" | "password", value: string) => void
}

const AdvancedSettingsSection: FC<AdvancedSettingsSectionProps> = ({
  values,
  onHeadersChange,
  onTimeoutChange,
  onBasicAuthChange
}) => {
  const [showAdvanced, setShowAdvanced] = useState(false)

  return (
    <div>
      <button
        type="button"
        onClick={() => setShowAdvanced(!showAdvanced)}
        className="flex items-center text-sm font-medium text-gray-700 mb-4 hover:text-gray-900"
      >
        <span className="mr-2">{showAdvanced ? "▼" : "▶"}</span>
        Advanced Settings
      </button>

      {showAdvanced && (
        <div className="space-y-4 pl-6">
          {values.direction === "outgoing" && (
            <div>
              <h4 className="text-sm font-medium text-gray-700 mb-2">
                Basic Authentication
              </h4>
              <p className="text-sm text-gray-500 mb-3">
                If the target API requires HTTP Basic Auth, enter credentials
                below. An Authorization header will be generated automatically.
              </p>
              <div className="grid grid-cols-2 gap-4">
                <ConnectorFormInput
                  label="Username"
                  value={values.config?.basic_auth?.username || ""}
                  onChange={value => onBasicAuthChange("username", value)}
                  placeholder="api_user"
                />
                <ConnectorFormInput
                  label="Password"
                  value={values.config?.basic_auth?.password || ""}
                  onChange={value => onBasicAuthChange("password", value)}
                  type="password"
                  placeholder="••••••••"
                />
              </div>
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Custom Headers (JSON)
            </label>
            <textarea
              value={JSON.stringify(values.config?.headers || {}, null, 2)}
              onChange={e => onHeadersChange(e.target.value)}
              placeholder='{\n  "Authorization": "Bearer token",\n  "X-API-Key": "your-key"\n}'
              className="w-full px-3 py-2 border border-gray-300 rounded-md font-mono text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              rows={5}
            />
            <p className="text-sm text-gray-500 mt-1">
              Optional custom HTTP headers for outgoing requests
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Timeout (seconds)
            </label>
            <input
              type="number"
              min={0}
              value={values.config?.timeout ?? ""}
              onChange={e => {
                if (e.target.value !== "") {
                  const n = parseInt(e.target.value, 10)
                  if (!isNaN(n)) onTimeoutChange(n)
                }
              }}
              onBlur={e => {
                if (e.target.value === "") onTimeoutChange(0)
              }}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default AdvancedSettingsSection
